<template>
  <div class="eachLrContentParentDiv">
    <div class="eachInputRow">
      <img :src="isPasswdType?icon_acc:icon_phone" height="24px" alt="">
      <van-field
          :disabled="isAutoFillPhoneNumber"
          :maxlength="isPasswdType?'15':'11'"
          :type="isPasswdType?'':'number'"
          v-model="value1"
          :placeholder="isPasswdType?'账号以字母开头(字母数字组合)':'请输入手机号码'"
          clearable
          @input="isPasswdType?onInput(1):null"
      />
    </div>
    <van-divider style="margin:5px"/>
    <div class="eachInputRow">
      <img :src="isPasswdType?icon_pwd:icon_ver" height="24px" alt="">
      <form style="width: 100%;">
        <van-field
            :maxlength="isPasswdType?'15':'11'"
            :type="isPasswdType?'password':'number'"
            v-model="value2"
            clearable
            :placeholder="isPasswdType?'请输入密码(字母数字组合)':'请输入验证码'"
            @input="() => { if (isPasswdType) onInput(2) }"
            autocomplete="false"
        >
          <template v-if="!isPasswdType" #button>
            <van-button @click="clickSendVerify" :disabled="value1.length!==11 || showVerText !== '获取验证码'"
                        size="small" type="primary"
                        :color="hcf.getMainColor()">{{ showVerText }}
            </van-button>
          </template>
        </van-field>
      </form>
    </div>
    <van-divider v-if="!isLogin && (hdi.inviteCode==='main'||hdi.inviteCode==='')" style="margin:5px"/>
    <div v-if="!isLogin && (hdi.inviteCode==='main'||hdi.inviteCode==='')" class="eachInputRow">
      <img :src="icon_invite" height="24px" alt="">
      <van-field
          maxlength="10"
          v-model="value3"
          placeholder="请输入邀请码(可不填)"
          clearable
          @input="onInput(3)"
      />
    </div>
    <van-divider v-if="showLastLine==null?true:showLastLine" style="margin:5px"/>
  </div>

</template>


<script setup>
  import icon_acc from '@/assets/icons/login/lr_acc.png';
  import icon_pwd from '@/assets/icons/login/lr_pwd.png';
  import icon_phone from '@/assets/icons/login/lr_phone.png';
  import icon_ver from '@/assets/icons/login/lr_ver.png';
  import icon_invite from '@/assets/icons/login/lr_invite.png';
  import {watch} from "vue";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {showToast} from "vant";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {hsp, SaveEnum} from "@/components/utils/HSp.js";
  import {useUserStore} from "@/stores/useUser.js";
  let useHttp = useHHttp();
  let useUser = useUserStore();

  const showVerText = ref("获取验证码");
  let downCounterTimer = null;
  let counter = 60;


  const value1 = ref('');
  const value2 = ref('');
  const value3 = ref('');
  if (hdi.inviteCode !== "" && hdi.inviteCode !== "main") {
    value3.value = hdi.inviteCode;
  }

  const props = defineProps(["autoFillPhoneNumber","showLastLine","isLogin", "isPasswdType", "valueChangeCallback"]);
  const isAutoFillPhoneNumber = ref((props.autoFillPhoneNumber  ?? false ) && useUser.phoneNumber!=="");

  if(isAutoFillPhoneNumber.value){
    value1.value = useUser.phoneNumber;
  }

  watch(() => [props.isPasswdType, props.isLogin], async () => {
    value1.value = "";
    value2.value = "";
    if (props.isLogin && props.isPasswdType) {
      value1.value = hsp.getString(SaveEnum.userAccount);
      //自动填充密码
      let isSavePwd = hsp.getBool(SaveEnum.savePwd);
      if (isSavePwd) {
        value2.value = hsp.getString(SaveEnum.userPwd);
      }
    }
    if(isAutoFillPhoneNumber.value){
      value1.value = useUser.phoneNumber;
    }
    props.valueChangeCallback(value1.value, value2.value, value3.value);
  }, {immediate: true});
  watch([value1, value2, value3], ([newA, newB, newC], [oldA, oldB, oldC]) => {
    props.valueChangeCallback(value1.value, value2.value, value3.value);
  })

  onUnmounted(() => {
    if (downCounterTimer != null) {
      clearInterval(downCounterTimer);
      downCounterTimer = null;
    }
  });


  function onInput(type) {
    // 只保留小写字母和数字
    let filtered;
    if(type === 2){
      filtered = (type === 1 ? value1 : type === 2 ? value2 : value3).value.replace(/[^a-zA-Z0-9]/g, '');
      // 如果第一个字符不是小写字母，去掉
      if (filtered && !/^[a-zA-Z]/.test(filtered)) {
        filtered = filtered.replace(/^[^a-zA-Z]+/, '');
      }
    }else{
      filtered = (type === 1 ? value1 : type === 2 ? value2 : value3).value.replace(/[^a-z0-9]/g, '');
      // 如果第一个字符不是小写字母，去掉
      if (filtered && !/^[a-z]/.test(filtered)) {
        filtered = filtered.replace(/^[^a-z]+/, '');
      }
    }
    (type === 1 ? value1 : type === 2 ? value2 : value3).value = filtered;
    log(value1.value)
    log(value2.value)
    log(value3.value)
    props.valueChangeCallback(value1.value, value2.value, value3.value);
  }


  function clickSendVerify() {
    if (!props.isLogin) {
      //注册先检测手机号是否存在
      useHttp.request("/app/reg/mobile/check", (data) => {
        if (data["Registed"]) {
          showToast("手机号已被注册,请更换您的手机号");
        } else {
          //没注册发验证码
          sendVerify();
        }
      }, {
        reqType: "POST",
        params: {
          "AppId": hdi.channelFlag,
          "AreaCode": "+86",
          "Mobile": value1.value,
        }
      });
    } else {
      sendVerify();
    }
  }

  function sendVerify() {
    useHttp.request("/app/captcha/sms/send",(data)=>{
      if (downCounterTimer != null) {
        clearInterval(downCounterTimer);
        downCounterTimer = null;
      }
      downCounterTimer = setInterval(() => {
        counter--;
        if (counter < 1) {
          clearInterval(downCounterTimer);
          downCounterTimer = null;
          counter = 60;
          showVerText.value = "获取验证码";
        } else {
          showVerText.value = "重新获取(" + counter + "s)";
        }
      }, 1000);
    },{
      params:{
        "AppId": hdi.channelFlag,
        "AreaCode": "+86",
        "Mobile": value1.value,
        "Biz": 0,
        "UserId":useUser.userId,
      }
    });
  }
</script>


<style scoped>
  .eachInputRow {
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .eachLrContentParentDiv {
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    background-color: white;
  }

</style>
